/*Recurso: Authenticate - Servicio de lectura del API: Verifica la autenticación del usuario obteniendo clave y contraseña
  Tareas:
    Auth              //*Autenticar
    AuthLDAP          //*Autenticar
*/

import axios from "axios";
import {IBodyAuth} from "./authenticate.modelo";
import {IBodyAuthLDAP} from "./authenticate.modelo";

  const API_URL = process.env.REACT_APP_API_URL + 'Authenticate/';

  //se genera una función por cada tarea del recurso api
    const cargaAuth = async (datosUsuario:IBodyAuth) => {
        //console.log ('***API: ' + API_URL + 'Auth', datosUsuario,  {headers: { 'content-type': 'text/json' }} )
        return await axios.post(API_URL + 'Auth', datosUsuario, 
            {headers: { 'content-type': 'text/json' }} )
    };

    const cargaAuthLDAP= async (datosUsuario:IBodyAuthLDAP) => {
        return await axios.post(API_URL + 'AuthLDAP', datosUsuario, 
            {headers: { 'content-type': 'text/json' }} )
    };

    /* const cargaAuthId = async (datosUsuario:any, id: number) => {
        return await axios.post(API_URL + 'AuthId' + id, datosUsuario, 
            {headers: { 'content-type': 'text/json' }} )
    }; */

const authenticateService = {
    cargaAuth: cargaAuth,
    cargaAuthLDAP: cargaAuthLDAP,
   /*  cargaAuthId: cargaAuthId, */
};

export default authenticateService;


/* return await axios({ method: 'post', url: API_URL,
        headers: {'Content-Type': 'application/json'}, 
        data: datosUsuario
      }); */